// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"198":"0b7cc828","690":"82c5a2ea"}[chunkId] + ".chunk.css";
};